const angular = require('angular');
const app = angular.module('learn-directives');
var Vivus = require('vivus');

/**
 * Defines the Sign In Directive which defines the sign in form behavior and markup
 * @argument {authorization} authorization injected to access the authorization resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('preauthHandler', ['Application', function(Application) {
    return {
      restrict: 'E',
      template: require('../../../templates/directives/preauth/preauth-handler.html'),
      controller: function() {
        var self = this;
        self.credentials = {domain: Application.navigation.getHost(), email: '', password: ''};
        self.loading = false;
        self.support_mailto = 'mailto:' + Application.supportEmailAddress;
        self.findPlace = function() {
          var url = Application.navigation.getUrl();

          var params = Application.navigation.getUrlParameters();
          if (params.invite_code) {
            return 'acceptinvite';
          }
          if (url.indexOf('signin') !== -1) {
            return 'signin';
          }
          if (url.indexOf('forgot') !== -1) {
            return 'forgot';
          }
          if (url.indexOf('resetpassword') !== -1) {
            return 'resetpassword';
          }
          if (url.indexOf('acceptinvite') !== -1) {
            return 'acceptinvite';
          }
          if (url.indexOf('saml-transition') !== -1) {
            if (window.name === "childsso") {
              window.opener.location.href = Application.navigation.getUrl();
              window.close();
              return;
            }
            if (!params.ts || ((parseInt(params.ts) + 300000) < new Date().valueOf())) {
              return Application.navigation.goTo('/signin', {});
            }
            return 'saml-transition';
          }
          if (url.indexOf('accept') !== -1) {
            return 'accept';
          }
          if (url.indexOf('register-with-userid') !== -1) {
            return 'register-with-userid';
          }
          if (url.indexOf('reset') !== -1) {
            return 'reset';
          }
          if (url.indexOf('register') !== -1) {
            return 'register';
          }
          if (url.indexOf('oauth-transition') !== -1) {
            return 'oauth-transition';
          }
        };

        self.goTo = function(place) {
          Application.navigation.goTo(place, {});
        };

        self.getRand = function (min, max) {
          return Math.floor(Math.random() * (max - min + 1) + min);
        };

        self.usesBackground = function(){
          return Application.backgroundInfo.custom;
        };

        self.backgroundCount = function(){
          if(self.usesBackground()){
            return Application.backgroundInfo.count;
          }
          return 0;
        };

        self.backgroundSettings = {
          'activated': self.usesBackground(),
          'chosen': self.getRand(1, self.backgroundCount()),
          bgClass: function () {
            if (self.backgroundSettings.activated === true && Application.LAYOUT !== 'continu') {
              return 'login--alt login--alt--' + self.backgroundSettings.chosen;
            } else if (self.backgroundSettings.activated === true && Application.LAYOUT === 'continu') {
              return 'login--alt login--alt--default login--alt--' + self.backgroundSettings.chosen;
            } else {
              return '';
            }
          }
        };

        var lineIntCounter = 0;
        var lineInt = setInterval(function(){
          var lineElement = document.querySelector('#login__line');
          if (lineElement){
            new Vivus('login__line', { duration: 200 });
            clearInterval(lineInt)
          }
          if(lineIntCounter === 10){
            clearInterval(lineInt);
          } else {
            lineIntCounter++;
          }
        },1000);
      },
      controllerAs: 'preauth'
    };
  }]);
